// frontend/src/pages/portfolio/sections/VideoSection.tsx
import React from "react";
import { PlayCircle } from "lucide-react";
import SectionEyebrow from "../components/SectionEyebrow";
import { container, sectionHeading, sectionReveal } from "../components/styles";

const VideoSection: React.FC = () => {
  return (
    <section
      id="walkthrough"
      className="border-t border-primary-200/30 bg-white py-16 sm:py-20"
      aria-labelledby="walkthrough-heading"
    >
      <div className={`${container} max-w-5xl`}>
        <div className={`max-w-2xl ${sectionReveal}`}>
          <SectionEyebrow icon={PlayCircle}>Walkthrough</SectionEyebrow>
          <h2 id="walkthrough-heading" className={`mt-4 mb-8 ${sectionHeading}`}>
            Watch the walkthrough
          </h2>
        </div>
        <div className="overflow-hidden rounded-2xl border border-gray-200 bg-black shadow-elevated ring-1 ring-primary-900/[0.04]">
          <video
            controls
            preload="metadata"
            playsInline
            className="block aspect-video w-full"
            aria-label="Time Tracker website walkthrough video"
          >
            <source src="/assets/TTG.mp4" type="video/mp4" />
            Your browser does not support embedded videos.
          </video>
        </div>
      </div>
    </section>
  );
};

export default VideoSection;
